import clsx from 'clsx';
import { ReactNode } from 'react';

import useLabels from '~hooks/useLabels';
import { Asset } from '~modules/media-library/model/Asset';
import { isAssetTemplateMaster, isAssetTemplateVersion } from '~modules/media-library/model/AssetFactory';

type BubbleProps = {
  children: ReactNode;
  title?: string;
  className?: string;
};
export function Bubble({ children, title = '', className = '' }: BubbleProps) {
  const text = String(title)
    .replace(/<br>/gm, '\n')
    .replace(/<br \/>/gm, '');

  return (
    <div
      className={clsx(
        'rounded-full',
        'bg-white',
        'w-4',
        'h-4',
        'text-black',
        'font-semibold',
        'leading-none',
        'select-none',
        'flex',
        'items-center',
        'justify-center',
        'font-sans',
        'text-sm cursor-help',
        className,
      )}
      title={text}
    >
      {children}
    </div>
  );
}

export function MasterVersionBubble({ asset }: { asset: Asset }) {
  const { labelMediaLibraryMasterBubble, labelMediaLibraryVersionBubble } = useLabels([
    'labelMediaLibraryMasterBubble',
    'labelMediaLibraryVersionBubble',
  ]);

  if (isAssetTemplateMaster(asset)) {
    return (
      <Bubble title={labelMediaLibraryMasterBubble} className="template-master-bubble">
        M
      </Bubble>
    );
  }

  if (isAssetTemplateVersion(asset)) {
    return (
      <Bubble title={labelMediaLibraryVersionBubble} className="template-version-bubble">
        V
      </Bubble>
    );
  }

  return null;
}

export function InfoBubble({ title }: { title: string }) {
  if (!title) return null;
  return (
    <Bubble title={title} className="info-bubble">
      i
    </Bubble>
  );
}

export function LawBubble({ title }: { title: string }) {
  if (!title) return null;
  return (
    <Bubble title={title} className="law-bubble">
      §
    </Bubble>
  );
}
